import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { GetAbsenceTimelineCardTitlePipe } from '@wilson/absences';
import {
  Absence,
  AssignmentStack,
  RoleAction,
  RolePermissionSubject,
} from '@wilson/interfaces';

import { TimelineHelperService } from '@wilson/shift-timeline/services';
import {
  NzDropdownMenuComponent,
  NzDropdownModule,
} from 'ng-zorro-antd/dropdown';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AuthorizationModule } from '@wilson/authorization';
import { TimeLineAbsenceTooltipComponent } from '../../timeline-absence-tooltip/timeline-absence-tooltip.component';
import { SelectedItemOutput } from '../../../interface';
import { AbilityServiceSignal } from '@casl/angular';
import { DeferredAbsenceCellViewCardHelperService } from '../../../deferred-absence-cell-view-card/deferred-absence-cell-view-card-helper.service';
import { Store } from '@ngxs/store';

@Component({
  selector: 'wilson-absence-cell-view-card',
  imports: [
    CommonModule,
    GetAbsenceTimelineCardTitlePipe,
    NzTooltipModule,
    TimeLineAbsenceTooltipComponent,
    NzDropdownModule,
    AuthorizationModule,
  ],
  templateUrl: './absence-cell-view-card.component.html',
  styleUrl: './absence-cell-view-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbsenceCellViewCardComponent {
  protected readonly timelineHelperService = inject(TimelineHelperService);
  protected readonly deferredAbsenceCellViewCardHelperService = inject(
    DeferredAbsenceCellViewCardHelperService,
  );
  private readonly store = inject(Store);

  @Input({ required: true }) absence!: AssignmentStack['absences'][0];
  @Input({ required: true }) isMoreThanOneAssignment!: boolean;
  @Input({ required: true }) contextMenuTemplate!: NzDropdownMenuComponent;
  @Input({ required: true }) stackHighlightIds!: string[];
  @Input({ required: true }) draggingItemId!: string | null;
  @Input({ required: true }) isMinimalMode!: boolean;
  @Input({ required: true }) isAbsenceDraggable!: boolean;
  @Input({ required: true }) isSelected!: boolean;

  @Output() absenceSelected = new EventEmitter<SelectedItemOutput>();
  @Output() absenceDragging = new EventEmitter<{
    absence: Absence & { id: string; isHighlighted: boolean };
    hasAbsenceUpdatePermissions: boolean;
  }>();
  @Output() absenceDragEnd = new EventEmitter<void>();

  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  public startDrag(
    absence: Absence & { id: string; isHighlighted: boolean },
    hasAbsenceUpdatePermissions: boolean,
  ): void {
    this.absenceDragging.emit({ absence, hasAbsenceUpdatePermissions });
  }
}
